"use client";

import { check_auth, getStudentDetail, loginAdmin } from "@/api";
import { isAdminOrFacultyUser } from "@/app/lib/isAdminUser";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

export default function AdminLoginPage() {
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    const checkExistingSession = async () => {
      try {
        const session = await check_auth();
        if (!session) {
          setIsCheckingAuth(false);
          return;
        }

        const user = await getStudentDetail();
        if (isAdminOrFacultyUser(user)) {
          router.replace("/admin/dashboard");
          return;
        }
      } catch (e) {
        // Ignore and let user login.
      } finally {
        setIsCheckingAuth(false);
      }
    };

    checkExistingSession();
  }, [router]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsSubmitting(true);

    try {
      await loginAdmin(email, password);
      const user = await getStudentDetail();

      if (!isAdminOrFacultyUser(user)) {
        setError("This account does not have admin/faculty access.");
        setIsSubmitting(false);
        return;
      }

      router.replace("/admin/dashboard");
    } catch (err) {
      setError(err?.response?.data?.message || "Admin login failed.");
      setIsSubmitting(false);
    }
  };

  if (isCheckingAuth) {
    return (
      <section className="w-full min-h-screen flex items-center justify-center px-4">
        <p className="text-gray-600">Checking session...</p>
      </section>
    );
  }

  return (
    <section className="w-full min-h-screen bg-[#f4f8ff] px-4 py-10 flex items-center justify-center">
      <div className="w-full max-w-md bg-white rounded-xl border border-gray-100 shadow-sm p-8">
        <h1 className="text-2xl font-bold text-[#1A1A1A] mb-2">Admin Login</h1>
        <p className="text-sm text-gray-600 mb-6">
          Sign in with your admin/faculty credentials.
        </p>

        {error ? <p className="text-sm text-red-600 mb-4">{error}</p> : null}

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <input
            type="email"
            placeholder="Admin email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border border-gray-300 rounded-md px-4 py-3 outline-none focus:border-[#0D6FEA]"
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-gray-300 rounded-md px-4 py-3 outline-none focus:border-[#0D6FEA]"
            required
          />
          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-primary text-white rounded-md py-3 font-medium disabled:opacity-60 cursor-pointer"
          >
            {isSubmitting ? "Signing in..." : "Login"}
          </button>
        </form>
      </div>
    </section>
  );
}

